import { ArrowUpRight } from "lucide-react";

function Marks({ hidden }) {
  return (
    <div className="flex shrink-0 items-center gap-16 pr-16" aria-hidden={hidden || undefined}>
      <span className="inline-flex items-center justify-center rounded-[9px] border-[3px] border-current p-1.5">
        <ArrowUpRight className="h-5 w-5" strokeWidth={2.6} />
      </span>
      <span className="flex h-9 w-9 items-center justify-center rounded-[7px] bg-current text-[15px] font-bold" style={{ color: "#6d6d74" }}>
        <span className="text-paper">B.</span>
      </span>
      <i className="fa-brands fa-airbnb text-[36px]" />
      <span className="text-[23px] font-bold tracking-[-0.02em]">Tripadvisor</span>
      <span className="text-[26px] font-bold tracking-[-0.03em]" style={{ fontFamily: "ui-sans-serif, system-ui, sans-serif" }}>
        Uber
      </span>
      <i className="fa-brands fa-lyft text-[30px]" />
    </div>
  );
}

const TECH = [
  "React",
  "Python",
  "Node.js",
  "AWS",
  "Google Cloud",
  "OpenAI",
  "TensorFlow",
  "Docker",
  "Kubernetes",
  "MongoDB",
  "Next.js",
  "Flutter",
];

function TechRow({ hidden }) {
  return (
    <div className="flex shrink-0 items-center gap-8 pr-8" aria-hidden={hidden || undefined}>
      {TECH.map((tech) => (
        <span key={tech} className="flex items-center gap-8">
          <span className="whitespace-nowrap text-[15px] font-medium tracking-[0.02em]">{tech}</span>
          <span className="h-1.5 w-1.5 rounded-full bg-brand" />
        </span>
      ))}
    </div>
  );
}

export default function LogoMarquee() {
  return (
    <div>
      <div className="marquee mt-9 overflow-hidden text-[#6d6d74]" data-testid="logo-marquee">
        <div className="animate-marquee flex w-max">
          <Marks />
          <Marks hidden />
        </div>
      </div>
      <div
        className="marquee mt-8 overflow-hidden border-y border-black/[0.08] py-5 text-[#6d6d74]"
        data-testid="tech-marquee"
      >
        <div className="animate-marquee-reverse flex w-max">
          <TechRow />
          <TechRow hidden />
        </div>
      </div>
    </div>
  );
}
